import ArticlesTab from "./components/ArticlesTab";
import ArticleTable from "./components/ArticleTable";
import TabNames from "./variables/TabNames.json" ;
import { Box, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import { ArticlesContext } from '../../contexts/ArticlesContext'; 
import { useContext } from 'react';


const Articles = () => 
{
    const { articles , totalCount } = useContext(ArticlesContext);  
    console.log(totalCount)
    return (                         

        <Box pt={{ base: "5px", md: "5px", xl: "5px" }}>

            <SimpleGrid>
                <ArticlesTab tabNames={TabNames}/> 
                <ArticleTable articles={articles || []} totalCount={totalCount} />
            </SimpleGrid>
        </Box>
    );

};
  
export default Articles;
  